import { AxiosResponse } from "axios";

import { ENDPOINTS } from "@api/endpoints";
import HttpClient from "@api/HttpClient";

export const processEvent = async (event: string): Promise<AxiosResponse> => {
  return await HttpClient.post(`${ENDPOINTS.processEvent}?event=${event}`);
};
